import { render, staticRenderFns } from "./TrainingSection.vue?vue&type=template&id=6c846088&scoped=true"
import script from "./TrainingSection.vue?vue&type=script&lang=js"
export * from "./TrainingSection.vue?vue&type=script&lang=js"
import style0 from "./TrainingSection.vue?vue&type=style&index=0&id=6c846088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c846088",
  null
  
)

export default component.exports